var map = {
	"./": [
		36868
	],
	"./Accessibility": [
		63761
	],
	"./Accessibility.js": [
		63761
	],
	"./Addition": [
		16736
	],
	"./Addition.js": [
		16736
	],
	"./Airplane": [
		93402
	],
	"./Airplane.js": [
		93402
	],
	"./AlarmClock": [
		40836
	],
	"./AlarmClock.js": [
		40836
	],
	"./AlertOperation": [
		62544
	],
	"./AlertOperation.js": [
		62544
	],
	"./AlertOutline": [
		61443
	],
	"./AlertOutline.js": [
		61443
	],
	"./AnimatedLoading1": [
		74630
	],
	"./AnimatedLoading1.js": [
		74630
	],
	"./AnimatedLoading2": [
		34623
	],
	"./AnimatedLoading2.js": [
		34623
	],
	"./AnimatedLoading3": [
		42832
	],
	"./AnimatedLoading3.js": [
		42832
	],
	"./AnimatedLoadingColorful": [
		75731
	],
	"./AnimatedLoadingColorful.js": [
		75731
	],
	"./AnimatedLoadingColorful2": [
		63137
	],
	"./AnimatedLoadingColorful2.js": [
		63137
	],
	"./ArrowBack": [
		50575
	],
	"./ArrowBack.js": [
		50575
	],
	"./ArrowDownRight": [
		16610
	],
	"./ArrowDownRight.js": [
		16610
	],
	"./ArrowDropDown": [
		80056
	],
	"./ArrowDropDown.js": [
		80056
	],
	"./ArrowDropUp": [
		94467
	],
	"./ArrowDropUp.js": [
		94467
	],
	"./ArrowForward": [
		33081
	],
	"./ArrowForward.js": [
		33081
	],
	"./ArrowLeft": [
		57608
	],
	"./ArrowLeft.js": [
		57608
	],
	"./ArrowRight": [
		94303
	],
	"./ArrowRight.js": [
		94303
	],
	"./BackToTop": [
		65743
	],
	"./BackToTop.js": [
		65743
	],
	"./BankSlip": [
		72286
	],
	"./BankSlip.js": [
		72286
	],
	"./Blog": [
		17054
	],
	"./Blog.js": [
		17054
	],
	"./BordererQuestionMark": [
		15992,
		5992
	],
	"./BordererQuestionMark.js": [
		15992,
		5992
	],
	"./BoxChecked": [
		74218
	],
	"./BoxChecked.js": [
		74218
	],
	"./BoxUnchecked": [
		48079
	],
	"./BoxUnchecked.js": [
		48079
	],
	"./Burger": [
		97639
	],
	"./Burger.js": [
		97639
	],
	"./Camera": [
		32143
	],
	"./Camera.js": [
		32143
	],
	"./Car": [
		74927
	],
	"./Car.js": [
		74927
	],
	"./CarLift": [
		71384
	],
	"./CarLift.js": [
		71384
	],
	"./Card": [
		37191
	],
	"./Card.js": [
		37191
	],
	"./CategoryAF": [
		5233
	],
	"./CategoryAF.js": [
		5233
	],
	"./CategoryAM": [
		80823
	],
	"./CategoryAM.js": [
		80823
	],
	"./CategoryAR": [
		18821
	],
	"./CategoryAR.js": [
		18821
	],
	"./CategoryAU": [
		28606
	],
	"./CategoryAU.js": [
		28606
	],
	"./CategoryBA": [
		84220
	],
	"./CategoryBA.js": [
		84220
	],
	"./CategoryBB": [
		93976
	],
	"./CategoryBB.js": [
		93976
	],
	"./CategoryBP": [
		15223
	],
	"./CategoryBP.js": [
		15223
	],
	"./CategoryBR": [
		33228
	],
	"./CategoryBR.js": [
		33228
	],
	"./CategoryBS": [
		65019
	],
	"./CategoryBS.js": [
		65019
	],
	"./CategoryCA": [
		17574
	],
	"./CategoryCA.js": [
		17574
	],
	"./CategoryCF": [
		30188
	],
	"./CategoryCF.js": [
		30188
	],
	"./CategoryCI": [
		54521
	],
	"./CategoryCI.js": [
		54521
	],
	"./CategoryCJ": [
		83385
	],
	"./CategoryCJ.js": [
		83385
	],
	"./CategoryCM": [
		67617
	],
	"./CategoryCM.js": [
		67617
	],
	"./CategoryCO": [
		40800
	],
	"./CategoryCO.js": [
		40800
	],
	"./CategoryCP": [
		37419
	],
	"./CategoryCP.js": [
		37419
	],
	"./CategoryCR": [
		72881
	],
	"./CategoryCR.js": [
		72881
	],
	"./CategoryDE": [
		17600
	],
	"./CategoryDE.js": [
		17600
	],
	"./CategoryEA": [
		84636
	],
	"./CategoryEA.js": [
		84636
	],
	"./CategoryED": [
		76910
	],
	"./CategoryED.js": [
		76910
	],
	"./CategoryEP": [
		2875
	],
	"./CategoryEP.js": [
		2875
	],
	"./CategoryES": [
		25682
	],
	"./CategoryES.js": [
		25682
	],
	"./CategoryET": [
		85190
	],
	"./CategoryET.js": [
		85190
	],
	"./CategoryFJ": [
		61295
	],
	"./CategoryFJ.js": [
		61295
	],
	"./CategoryFM": [
		39444
	],
	"./CategoryFM.js": [
		39444
	],
	"./CategoryFS": [
		39965
	],
	"./CategoryFS.js": [
		39965
	],
	"./CategoryGA": [
		39764
	],
	"./CategoryGA.js": [
		39764
	],
	"./CategoryIA": [
		43408
	],
	"./CategoryIA.js": [
		43408
	],
	"./CategoryIM": [
		92943
	],
	"./CategoryIM.js": [
		92943
	],
	"./CategoryIN": [
		92288
	],
	"./CategoryIN.js": [
		92288
	],
	"./CategoryLI": [
		27483
	],
	"./CategoryLI.js": [
		27483
	],
	"./CategoryMD": [
		26416
	],
	"./CategoryMD.js": [
		26416
	],
	"./CategoryME": [
		87159
	],
	"./CategoryME.js": [
		87159
	],
	"./CategoryMO": [
		83559
	],
	"./CategoryMO.js": [
		83559
	],
	"./CategoryMS": [
		25461
	],
	"./CategoryMS.js": [
		25461
	],
	"./CategoryNA": [
		65341
	],
	"./CategoryNA.js": [
		65341
	],
	"./CategoryPA": [
		36258
	],
	"./CategoryPA.js": [
		36258
	],
	"./CategoryPE": [
		78068
	],
	"./CategoryPE.js": [
		78068
	],
	"./CategoryPF": [
		17268
	],
	"./CategoryPF.js": [
		17268
	],
	"./CategoryPI": [
		29661
	],
	"./CategoryPI.js": [
		29661
	],
	"./CategoryRE": [
		20227
	],
	"./CategoryRE.js": [
		20227
	],
	"./CategoryRG": [
		3343
	],
	"./CategoryRG.js": [
		3343
	],
	"./CategorySA": [
		65954
	],
	"./CategorySA.js": [
		65954
	],
	"./CategorySE": [
		59556
	],
	"./CategorySE.js": [
		59556
	],
	"./CategoryTB": [
		99189
	],
	"./CategoryTB.js": [
		99189
	],
	"./CategoryTE": [
		29806
	],
	"./CategoryTE.js": [
		29806
	],
	"./CategoryTF": [
		21694
	],
	"./CategoryTF.js": [
		21694
	],
	"./CategoryUD": [
		82259
	],
	"./CategoryUD.js": [
		82259
	],
	"./CertainExchange": [
		10172
	],
	"./CertainExchange.js": [
		10172
	],
	"./Chat": [
		89480
	],
	"./Chat.js": [
		89480
	],
	"./ChatSuccess": [
		86958
	],
	"./ChatSuccess.js": [
		86958
	],
	"./ChatWarning": [
		63868
	],
	"./ChatWarning.js": [
		63868
	],
	"./Check": [
		70923
	],
	"./Check.js": [
		70923
	],
	"./CheckCircle": [
		19965
	],
	"./CheckCircle.js": [
		19965
	],
	"./CheckThin": [
		9457
	],
	"./CheckThin.js": [
		9457
	],
	"./ChevronDown": [
		14045
	],
	"./ChevronDown.js": [
		14045
	],
	"./ChevronDownCircle": [
		97183
	],
	"./ChevronDownCircle.js": [
		97183
	],
	"./ChevronLeft": [
		49378
	],
	"./ChevronLeft.js": [
		49378
	],
	"./ChevronRight": [
		14515
	],
	"./ChevronRight.js": [
		14515
	],
	"./ChevronUp": [
		37715
	],
	"./ChevronUp.js": [
		37715
	],
	"./Christmas": [
		57416
	],
	"./Christmas.js": [
		57416
	],
	"./Clock": [
		50739
	],
	"./Clock.js": [
		50739
	],
	"./Close": [
		54283
	],
	"./Close.js": [
		54283
	],
	"./CloseCircle": [
		33551
	],
	"./CloseCircle.js": [
		33551
	],
	"./CloseCircleFilled": [
		70643
	],
	"./CloseCircleFilled.js": [
		70643
	],
	"./Coin": [
		85440
	],
	"./Coin.js": [
		85440
	],
	"./Conversation": [
		28983
	],
	"./Conversation.js": [
		28983
	],
	"./Copy": [
		20330
	],
	"./Copy.js": [
		20330
	],
	"./CreditCard": [
		66372
	],
	"./CreditCard.js": [
		66372
	],
	"./Cupom": [
		53465
	],
	"./Cupom.js": [
		53465
	],
	"./CupomPromotion": [
		88060
	],
	"./CupomPromotion.js": [
		88060
	],
	"./CustomerContact": [
		69887
	],
	"./CustomerContact.js": [
		69887
	],
	"./Delivery1h": [
		94825
	],
	"./Delivery1h.js": [
		94825
	],
	"./Delivery24h": [
		64625
	],
	"./Delivery24h.js": [
		64625
	],
	"./DeliveryBox": [
		64521
	],
	"./DeliveryBox.js": [
		64521
	],
	"./DeliveryDefault": [
		88522
	],
	"./DeliveryDefault.js": [
		88522
	],
	"./DeliveryDefaultFilled": [
		66090
	],
	"./DeliveryDefaultFilled.js": [
		66090
	],
	"./DeliveryFree": [
		80013
	],
	"./DeliveryFree.js": [
		80013
	],
	"./DeliveryM": [
		41748
	],
	"./DeliveryM.js": [
		41748
	],
	"./DeliveryRTomorrow": [
		18317
	],
	"./DeliveryRTomorrow.js": [
		18317
	],
	"./DeliverySuccess": [
		4471
	],
	"./DeliverySuccess.js": [
		4471
	],
	"./DeliveryWarning": [
		20061
	],
	"./DeliveryWarning.js": [
		20061
	],
	"./Dislike": [
		71846
	],
	"./Dislike.js": [
		71846
	],
	"./Done": [
		12170
	],
	"./Done.js": [
		12170
	],
	"./DoneCircle": [
		37944
	],
	"./DoneCircle.js": [
		37944
	],
	"./Edit": [
		78218
	],
	"./Edit.js": [
		78218
	],
	"./EmailAt": [
		69185
	],
	"./EmailAt.js": [
		69185
	],
	"./ErrorOutline": [
		76813
	],
	"./ErrorOutline.js": [
		76813
	],
	"./Exchange": [
		22917
	],
	"./Exchange.js": [
		22917
	],
	"./ExchangeCircle": [
		73830
	],
	"./ExchangeCircle.js": [
		73830
	],
	"./ExpressDelivery": [
		16885
	],
	"./ExpressDelivery.js": [
		16885
	],
	"./ExtendedWarranty": [
		95328
	],
	"./ExtendedWarranty.js": [
		95328
	],
	"./Facebook": [
		66244
	],
	"./Facebook.js": [
		66244
	],
	"./FastDelivery": [
		66563
	],
	"./FastDelivery.js": [
		66563
	],
	"./FastMarket": [
		70310
	],
	"./FastMarket.js": [
		70310
	],
	"./FeaturedVideo": [
		32376
	],
	"./FeaturedVideo.js": [
		32376
	],
	"./Filter": [
		99933
	],
	"./Filter.js": [
		99933
	],
	"./GenericImageIcon": [
		68298
	],
	"./GenericImageIcon.js": [
		68298
	],
	"./Guarantee": [
		58823
	],
	"./Guarantee.js": [
		58823
	],
	"./GuaranteeFilled": [
		54795
	],
	"./GuaranteeFilled.js": [
		54795
	],
	"./Heart": [
		77339
	],
	"./Heart.js": [
		77339
	],
	"./HelpOutline": [
		9038
	],
	"./HelpOutline.js": [
		9038
	],
	"./InfoCircle": [
		66099
	],
	"./InfoCircle.js": [
		66099
	],
	"./Instagram": [
		10246
	],
	"./Instagram.js": [
		10246
	],
	"./Lightning": [
		78125
	],
	"./Lightning.js": [
		78125
	],
	"./Like": [
		19302
	],
	"./Like.js": [
		19302
	],
	"./Link": [
		83542
	],
	"./Link.js": [
		83542
	],
	"./LinkedIn": [
		75206
	],
	"./LinkedIn.js": [
		75206
	],
	"./LocalActivity": [
		31304
	],
	"./LocalActivity.js": [
		31304
	],
	"./LogoAliExpress": [
		90918
	],
	"./LogoAliExpress.js": [
		90918
	],
	"./LogoBlogLu": [
		29192
	],
	"./LogoBlogLu.js": [
		29192
	],
	"./LogoEpoca": [
		45832
	],
	"./LogoEpoca.js": [
		45832
	],
	"./LogoEpocaName": [
		99638
	],
	"./LogoEpocaName.js": [
		99638
	],
	"./LogoInfluenciadorMagalu": [
		44756,
		4756
	],
	"./LogoInfluenciadorMagalu.js": [
		44756,
		4756
	],
	"./LogoKabum": [
		76546
	],
	"./LogoKabum.js": [
		76546
	],
	"./LogoMagalu": [
		32153
	],
	"./LogoMagalu.js": [
		32153
	],
	"./LogoMagaluDesktop": [
		5802
	],
	"./LogoMagaluDesktop.js": [
		5802
	],
	"./LogoMagaluRecommends": [
		96106
	],
	"./LogoMagaluRecommends.js": [
		96106
	],
	"./LogoMagazine": [
		605
	],
	"./LogoMagazine.js": [
		605
	],
	"./LogoNetshoesCircle": [
		85450
	],
	"./LogoNetshoesCircle.js": [
		85450
	],
	"./LogoNetshoesName": [
		38936
	],
	"./LogoNetshoesName.js": [
		38936
	],
	"./LogoNetshoesRounded": [
		89165
	],
	"./LogoNetshoesRounded.js": [
		89165
	],
	"./LogoParceiroMagalu": [
		35871
	],
	"./LogoParceiroMagalu.js": [
		35871
	],
	"./LogoZattini": [
		24644
	],
	"./LogoZattini.js": [
		24644
	],
	"./LogoZattiniName": [
		7541
	],
	"./LogoZattiniName.js": [
		7541
	],
	"./LuizaCard": [
		35208
	],
	"./LuizaCard.js": [
		35208
	],
	"./MailOutline": [
		67941
	],
	"./MailOutline.js": [
		67941
	],
	"./MoneyPig": [
		50067
	],
	"./MoneyPig.js": [
		50067
	],
	"./Muted": [
		31055
	],
	"./Muted.js": [
		31055
	],
	"./Notifications": [
		21713
	],
	"./Notifications.js": [
		21713
	],
	"./Offers": [
		81097
	],
	"./Offers.js": [
		81097
	],
	"./OpenLink": [
		42609
	],
	"./OpenLink.js": [
		42609
	],
	"./Package": [
		61610
	],
	"./Package.js": [
		61610
	],
	"./PackageAlert": [
		14996
	],
	"./PackageAlert.js": [
		14996
	],
	"./Person": [
		11257
	],
	"./Person.js": [
		11257
	],
	"./Phone": [
		99073
	],
	"./Phone.js": [
		99073
	],
	"./PickupStore": [
		43094
	],
	"./PickupStore.js": [
		43094
	],
	"./Pin": [
		66857
	],
	"./Pin.js": [
		66857
	],
	"./Pinterest": [
		50986
	],
	"./Pinterest.js": [
		50986
	],
	"./Pix": [
		57298
	],
	"./Pix.js": [
		57298
	],
	"./Play": [
		55235
	],
	"./Play.js": [
		55235
	],
	"./Podcast": [
		17873
	],
	"./Podcast.js": [
		17873
	],
	"./PodcastCircle": [
		98259
	],
	"./PodcastCircle.js": [
		98259
	],
	"./PriceTag": [
		56056
	],
	"./PriceTag.js": [
		56056
	],
	"./PrivacyPolitic": [
		18336
	],
	"./PrivacyPolitic.js": [
		18336
	],
	"./Profile": [
		78438
	],
	"./Profile.js": [
		78438
	],
	"./QRCode": [
		25250
	],
	"./QRCode.js": [
		25250
	],
	"./Question": [
		91152
	],
	"./Question.js": [
		91152
	],
	"./Receipt": [
		3708
	],
	"./Receipt.js": [
		3708
	],
	"./ReturnCircle": [
		12961
	],
	"./ReturnCircle.js": [
		12961
	],
	"./RobberyTheft": [
		56987
	],
	"./RobberyTheft.js": [
		56987
	],
	"./RobberyTheftFull": [
		77018
	],
	"./RobberyTheftFull.js": [
		77018
	],
	"./Rules": [
		9001
	],
	"./Rules.js": [
		9001
	],
	"./Sac": [
		36575
	],
	"./Sac.js": [
		36575
	],
	"./Search": [
		70833
	],
	"./Search.js": [
		70833
	],
	"./SecurityTip": [
		13331
	],
	"./SecurityTip.js": [
		13331
	],
	"./SellerStore": [
		43847
	],
	"./SellerStore.js": [
		43847
	],
	"./Send": [
		50285
	],
	"./Send.js": [
		50285
	],
	"./ServiceBabyShower": [
		48648
	],
	"./ServiceBabyShower.js": [
		48648
	],
	"./ServiceCard": [
		98182
	],
	"./ServiceCard.js": [
		98182
	],
	"./ServiceConsortium": [
		26915
	],
	"./ServiceConsortium.js": [
		26915
	],
	"./ServiceControlPlan": [
		55148
	],
	"./ServiceControlPlan.js": [
		55148
	],
	"./ServiceGoldClient": [
		16030
	],
	"./ServiceGoldClient.js": [
		16030
	],
	"./ServiceHomeIntelligent": [
		14620
	],
	"./ServiceHomeIntelligent.js": [
		14620
	],
	"./ServiceHomeSecurity": [
		1086
	],
	"./ServiceHomeSecurity.js": [
		1086
	],
	"./ServiceLuizaSeg": [
		2492
	],
	"./ServiceLuizaSeg.js": [
		2492
	],
	"./ServiceMagaluEmp": [
		60929
	],
	"./ServiceMagaluEmp.js": [
		60929
	],
	"./ServiceMarketplace": [
		54731
	],
	"./ServiceMarketplace.js": [
		54731
	],
	"./ServiceMarriage": [
		37212
	],
	"./ServiceMarriage.js": [
		37212
	],
	"./ServicePartner": [
		68621
	],
	"./ServicePartner.js": [
		68621
	],
	"./ServiceSolutions": [
		69848
	],
	"./ServiceSolutions.js": [
		69848
	],
	"./Share": [
		80297
	],
	"./Share.js": [
		80297
	],
	"./ShipmentInAccordance": [
		72333
	],
	"./ShipmentInAccordance.js": [
		72333
	],
	"./ShoppingBag": [
		4868
	],
	"./ShoppingBag.js": [
		4868
	],
	"./ShoppingBagFast": [
		98296
	],
	"./ShoppingBagFast.js": [
		98296
	],
	"./Sort": [
		13571
	],
	"./Sort.js": [
		13571
	],
	"./SortArrows": [
		43941
	],
	"./SortArrows.js": [
		43941
	],
	"./Star": [
		57186
	],
	"./Star.js": [
		57186
	],
	"./StarGroup": [
		35233
	],
	"./StarGroup.js": [
		35233
	],
	"./StarHalf": [
		58940
	],
	"./StarHalf.js": [
		58940
	],
	"./StarOutline": [
		64353
	],
	"./StarOutline.js": [
		64353
	],
	"./Store": [
		13750
	],
	"./Store.js": [
		13750
	],
	"./Telegram": [
		84830
	],
	"./Telegram.js": [
		84830
	],
	"./ThumbUp": [
		33737
	],
	"./ThumbUp.js": [
		33737
	],
	"./Tiktok": [
		4774
	],
	"./Tiktok.js": [
		4774
	],
	"./Timer": [
		21342
	],
	"./Timer.js": [
		21342
	],
	"./Tools": [
		18894
	],
	"./Tools.js": [
		18894
	],
	"./TotalSales": [
		86732
	],
	"./TotalSales.js": [
		86732
	],
	"./Tune": [
		40295
	],
	"./Tune.js": [
		40295
	],
	"./Twitter": [
		38830
	],
	"./Twitter.js": [
		38830
	],
	"./Unmuted": [
		94617
	],
	"./Unmuted.js": [
		94617
	],
	"./UserReviewIcon": [
		33112
	],
	"./UserReviewIcon.js": [
		33112
	],
	"./VerifiedBadge": [
		70856
	],
	"./VerifiedBadge.js": [
		70856
	],
	"./Video": [
		80929
	],
	"./Video.js": [
		80929
	],
	"./VideoCircle": [
		11966
	],
	"./VideoCircle.js": [
		11966
	],
	"./ViewModule": [
		65370
	],
	"./ViewModule.js": [
		65370
	],
	"./WarningOutline": [
		81858
	],
	"./WarningOutline.js": [
		81858
	],
	"./WhatsApp": [
		5785
	],
	"./WhatsApp.js": [
		5785
	],
	"./Youtube": [
		63724
	],
	"./Youtube.js": [
		63724
	],
	"./index": [
		36868
	],
	"./index.js": [
		36868
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70017;
module.exports = webpackAsyncContext;